import { render, staticRenderFns } from "./VehicleImageRepair.vue?vue&type=template&id=48ae92c0&scoped=true&"
import script from "./VehicleImageRepair.vue?vue&type=script&lang=js&"
export * from "./VehicleImageRepair.vue?vue&type=script&lang=js&"
import style0 from "./VehicleImageRepair.vue?vue&type=style&index=0&id=48ae92c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae92c0",
  null
  
)

export default component.exports